// extracted by mini-css-extract-plugin
export default {"productImg":"UnavailableProducts_productImg__azcs7","unavailable_products_modal":"UnavailableProducts_unavailable_products_modal__8zlgm"};